import {enqueueSnackbar} from "notistack";

export default function errorToast(message) {
    return enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }
    })
}